import { validatePresence } from 'ember-changeset-validations/validators';

export default {
  name: validatePresence({ presence: true, ignoreBlank: true, message: 'This is a required field' }),
};
